// extracted by mini-css-extract-plugin
export default {"form-control":"Button_form-control__-qbZl","btn":"Button_btn__elon-"};